export const Defaults = {
	hp: 0,
	sold: 0,
	contract_id: '828',
	contract_name: 'Default Lead',
	leadinfo: {
		full_name: 'Defaults',
		phone: '2693253095',
		email: 'fakedefault@gmail.com',
	},
	phone_number: '8778683344',
	fields: {
		cta_header: {
			body: `<p>Within the next 24 hours, you will receive an important phone call from one of our attorneys or case agents that will help gather the final, required information to file your claim.</p>
							<p>You may not recognize this phone number, but please pick up the call so we can complete your claim and our attorney can immediately get to work for you.&nbsp;</p>
							<p>Please do not contact another law firm before we talk with you.</p>
							<p>There is <strong><u>NO charge</u></strong> to you for exploring your options with us. You have absolutely no obligations and there is no upfront charge to you at all, your attorney only gets paid if he wins a settlement for your case!</p>`,
			title: `<p>
								<strong style="color: rgb(230, 0, 0);">Thank you!</strong>
								Based on your answers, your claim may be eligible for significant
                <span style="color: rgb(230, 0, 0);">compensation</span>.
							</p>`,
			button_text: '',
		},
	},
	internal: 1,
	type: 'Internal',
};

export const DefaultIntroFields = {
	title: 'Thank you for your submission',
	body: '<p>We need more information to see if you qualify. Answer the questions below so you can immediately get started with your free, confidential claim review.</p><p>It takes just 2-3 minutes and if you qualify, we email your case documents for your review and signature.</p>',
};
